export default __webpack_public_path__ + "static/media/arrow-right.2c92b9e9.svg";